module.exports = __webpack_public_path__ + "f28d2e2ffddd8e623816266eada29802.svg";